import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  height: 100%;
`;

const Placeholder = styled.div`
  color: rgba(255, 255, 255, 0.4);
  font-size: 12px;
`;

export default function DemosModule() {
  const [demos, setDemos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // TODO: Fetch demos from API
    setLoading(false);
  }, []);

  if (loading) {
    return <Placeholder>Loading demos...</Placeholder>;
  }

  // Match mock: keep this module empty for now
  return <Container />;
}

